import {
	useNavigationLayoutContext
} from '~/contexts/NavigationLayoutContext';

import {
	type NavigationLayout
} from '~/config/navigationMigration';

/**
 * Hook to manage navigation layout preference
 *
 * Manages the user's navigation layout preference (old/new) with localStorage persistence.
 * Respects the migration timeline - user preference is only used when toggle is visible.
 * After month 3, always returns the default layout regardless of stored preference.
 *
 * @returns Tuple containing:
 *   - currentLayout: 'old' | 'new' - The active layout
 *   - setLayout: (layout: 'old' | 'new') => void - Function to change layout
 *   - showToggle: boolean - Whether toggle should be visible
 */
function useNavigationLayout(): [
	NavigationLayout,
	(layout: NavigationLayout) => void,
	boolean,
	] {
	const { currentLayout, setLayout, showToggle } = useNavigationLayoutContext();

	return [
		currentLayout,
		setLayout,
		showToggle,
	];
}

export default useNavigationLayout;
